import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';

import { AppState } from 'src/app';
import { SessionService } from 'src/core/services/session.service';
import { StorageService } from 'src/core/services/storage.service';

@Injectable()
export class SessionGuard implements CanActivate, CanActivateChild {
  constructor(
    private store: Store<AppState>,
    private router: Router,
    private sessionService: SessionService,
    private storageService: StorageService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    return this.resolveAuth();
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    return this.canActivate(route, state);
  }

  private resolveAuth(): Promise<boolean> {
    return Promise.resolve(true);
  }
}
